<template>
  <ion-app>
    <ion-menu side="end" content-id="main-content">
      <ion-header>
        <ion-toolbar>
          <ion-title>Menu</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <ion-list>
          <ion-item>
            <ion-label>
              <a href="/">Suivi de la journée</a>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label>
              <a href="/add-product">Ajouter un produit</a>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label>
              <a href="/see-products">Voir les produits</a>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label>
              <a href="/weight">Poids</a>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label>
              <a href="/graph">Graph</a>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label>
              <a href="/grocery">Liste de courses</a>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label>v1.1</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
    </ion-menu>
    <router-view></router-view>
  </ion-app>
</template>

<script>
import {
  IonApp,
  IonContent,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonTitle,
  IonToolbar,
} from '@ionic/vue';

export default {
  name: 'App',
  components: {
    IonApp,
    IonContent,
    IonHeader,
    IonItem,
    IonLabel,
    IonList,
    IonMenu,
    IonTitle,
    IonToolbar,
  },
};
</script>
